import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { concatMap, map, tap, Subscription, BehaviorSubject, catchError, mergeMap, take, forkJoin, of } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@shared/services/auth/auth.service';
import { AppService, EncryptionService, SnackbarService, LoadingService } from '@shared/services/core';
import * as CryptoJS from 'crypto-js';
import { PasswordPolicyComponent } from '../../../../pages/auth/password-policy/password-policy.component';
import { HttpResponse } from '@angular/common/http'
import { SessionService } from '@shared/services/auth/session.service';
import {
  LoginCredentialWithClientSecret,
  ClientUserData,
  UserLicenseDetail,
  ProfessionalUserData,
  CookieData,
  AuthFormNotificationType,
  AuthFormType,
  UnspecifiedUserTypeData,
  MFAPrefrences,
  AuthAPIResponse,
  MFAClientIdPayload,
  MFAUserPreferences,
  APIResponse

} from '@shared/models/auth.interface';
import { BusinessError, CategorizedError } from '@modules/error/classes';
import { DashboardService } from '@shared/services/dashboard/dashboard.service';
import { LogService } from '@shared/services/core/log.service';
import { TermsAndConditionsDialogComponent } from '@core/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { BusinessOperationErrorTypes } from '@shared/models/error.interface';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CookieService } from 'ngx-cookie';
import { Menu } from '@shared/models/sidenav.interface';
import { AuthMFAService } from '@shared/services/auth/auth-mfa.service';
import { MfaDataService } from '@shared/services/mfa-data.service';
import { UserAccLockedPayload } from '@shared/models/mfa-prefrences.interface';
import { Session } from 'inspector';

const demoAnimation = trigger('demoAnimation', [
  transition(':enter', [
    style({ transform: 'translateX({{ from }})' }),
    animate('200ms', style({ transform: 'translateX(0%)' }))
  ]),
])

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  animations: [demoAnimation]
})
export class LoginFormComponent implements OnInit, OnDestroy {
  @Output() notify = new EventEmitter<AuthFormNotificationType | null>();
  @Output() formChange = new EventEmitter<AuthFormType>();
  @Input() accessCode: string = '';
  @Input() lastFormTracker = new BehaviorSubject<AuthFormType>("ACCESSCODE");

  authSubscription: Subscription | undefined;
  formValueChangesSubscription!: Subscription;
  hidePassword: boolean = true;
  toggleIcon: 'fa-eye' | 'fa-eye-slash' = 'fa-eye';
  public isPasswordVisible: boolean = false;
  loginForm: FormGroup = new FormGroup({
    userID: new FormControl('', [Validators.required, Validators.maxLength(10), clientIdFieldValidator()]),
    password: new FormControl('', Validators.required),
    rememberMe: new FormControl(false),
    Captcha: new FormControl(''),
    NotRobotCheckbox: new FormControl(false),
  })
  clientMfa!: MFAUserPreferences;
  MfaPrefInfo!: MFAPrefrences;
  showerrorMessage: string = '';
  deviceToken: string = '';
  cookieValue: any;
  loginSubscription!: Subscription;
  CaptchaMismatchError = false;
  @ViewChild('captchaCanvas', { static: false }) canvasRef!: ElementRef<HTMLCanvasElement>;
  captchaText = '';
  userInput = '';
  valid = true;
  ctx!: CanvasRenderingContext2D;
  attemptsLeft!: number;
  captchaRendered: boolean = false;
  productVer: string = "false";

  // Checkbox and CAPTCHA visibility properties
  isNotRobotChecked: boolean = false;
  showCaptcha: boolean = false;
  captchaCompleted: boolean = false;

  constructor(
    private authService: AuthService,
    private appService: AppService,
    private loadingService: LoadingService,
    private logService: LogService,
    private snackbarService: SnackbarService,
    private dashboardService: DashboardService,
    private matDialog: MatDialog,
    private router: Router,
    public dialog: MatDialog,
    private encryptionService: EncryptionService,
    private deviceDetectorService: DeviceDetectorService,
    private authMFAService: AuthMFAService,
    private mfaDataService: MfaDataService,
    private cookieService: CookieService,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {
    this.formValueChangesSubscription = this.loginForm.valueChanges
      .subscribe((_: any) => this.notify.emit(null));

      this.productVer = String(this.sessionService.getNonEncryptedStorageMapping("productVer"));


    this.loginSubscription = this.mfaDataService.loginTrigger$
      .subscribe(
        (msg: string | { error: string } | { otp: string; mfaAuthType: string; securityQuestions?: any }) => {
          if (msg && typeof msg === 'object' && 'otp' in msg && 'mfaAuthType' in msg) {
            this.clientMfa.DefaultAuth = msg.mfaAuthType;
            if (msg.securityQuestions) {
              const verifySecurityAns = [
                {
                  id: msg.securityQuestions.question1,
                  //question: msg.securityQuestions.question1Id,
                  answer: msg.securityQuestions.answer1
                },
                {
                  id: msg.securityQuestions.question2,
                  //question: msg.securityQuestions.question2Id,
                  answer: msg.securityQuestions.answer2
                }
              ];
              this.verifyOTP(verifySecurityAns);
            } else {
              this.verifyOTP(msg.otp);
            }
          }
        }
      );
    // this.mfaDataService.loginTrigger$.subscribe((msg: string | { error: string } | { otp: string; mfaAuthType: string }) => {
    //   if (msg && typeof msg === 'object' && 'otp' in msg && 'mfaAuthType' in msg) {
    //     this.verifyOTP(msg.otp); 
    //     this.clientMfa.DefaultAuth = msg.mfaAuthType; 
    //   }
    // });

  }

  ngAfterViewChecked(): void {
    if ((this.attemptsLeft === 1 || this.attemptsLeft === 2) && this.showCaptcha && !this.captchaRendered) {
      const canvas = this.canvasRef?.nativeElement;
      if (canvas) {
        this.ctx = canvas.getContext('2d')!;
        this.generateCaptcha();
        this.captchaRendered = true;
        this.loginForm.get('Captcha')?.setValidators([Validators.required]);
      }
    }
  }

  playAudio() {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(this.captchaText.split('').join(' '));
      utterance.rate = 0.8;
      utterance.pitch = 1.1;
      utterance.lang = 'en-US';
      speechSynthesis.speak(utterance);
    } else {
      alert('Sorry, your browser does not support audio CAPTCHA.');
    }
  }

  private fonts = ['Arial', 'Courier', 'Georgia', 'Verdana', 'Tahoma'];
  private randomColor(min: number, max: number): string {
    const r = min + Math.floor(Math.random() * (max - min));
    const g = min + Math.floor(Math.random() * (max - min));
    const b = min + Math.floor(Math.random() * (max - min));
    return `rgb(${r},${g},${b})`;
  }

  generateCaptcha() {
    const canvas = this.canvasRef.nativeElement;
    const ctx = this.ctx;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = this.randomColor(180, 255);
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
    this.captchaText = Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');

    // Draw CAPTCHA
    for (let i = 0; i < this.captchaText.length; i++) {
      const char = this.captchaText[i];
      ctx.font = `${20 + Math.random() * 10}px ${this.fonts[Math.floor(Math.random() * this.fonts.length)]}`;
      ctx.fillStyle = this.randomColor(10, 150);
      ctx.save();
      ctx.translate(20 + i * 22, 30);
      ctx.rotate((Math.random() - 0.5) * 0.6);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }

    // Noise lines
    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = this.randomColor(50, 160);
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    // Dots
    for (let i = 0; i < 50; i++) {
      ctx.fillStyle = this.randomColor(0, 255);
      ctx.beginPath();
      ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, Math.PI * 2);
      ctx.fill();
    }

    this.userInput = '';
    this.valid = true;
  }

  checkForMFA() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    // let productVer=this.sessionService.getNonEncryptedStorageMapping("productVer");
    // if (String(productVer) === "true") {
    //   //this.login();
    // }
    else {
      if ((this.attemptsLeft === 1 || this.attemptsLeft === 2) && this.captchaRendered) {
        this.userInput = this.loginForm.get('Captcha')?.value;
        this.valid = this.userInput === this.captchaText;
        if (!this.valid) {
          this.generateCaptcha();
          this.loginForm.get("Captcha")?.setErrors({ captchaMismatch: true });
          this.CaptchaMismatchError = true;
          this.showerrorMessage = '';
          return; // Don't proceed if captcha is not valid
        } else {
          this.userInput = '';
          this.CaptchaMismatchError = false;
        }
      }
      // Only run this if the cookie was found
      //  if (this.checkMfaCookie(this.loginForm.get('userID')?.value)) {
      //   this.login();
      //   return;
      // }

      this.loadingService.showLoading();
      const { userID, password } = this.loginForm?.value;
      this.deviceToken = this.checkMfaCookie(this.loginForm.get('userID')?.value) ? this.cookieValue : this.generateRandomString(25);
      const requestBody: LoginCredentialWithClientSecret = {
        code: this.accessCode,
        userID,
        password: this.authService.encodeBase64(password),
        clientId: this.appService.getAppSettings().cfgPkg.cfgC,
        //clientSecret: this.appService.getAppSettings().cfgPkg.cfgD,
        deviceToken: this.deviceToken,
        BaseURL: window.location.hostname
      }

      this.authSubscription = this.authService.getMFAWithPrefences(requestBody).pipe(
        catchError((error: any) => {
          const code = error.description.slice(0, 3);
          if (code === '700') { this.sendAccountLockedNotification(userID); }
          if (code === '600' || code === '700' || code === '800') {
            this.showerrorMessage = error?.description?.slice(4);
            //this.notify.next('null');
            this.attemptsLeft = error.data?.attemptsLeft ?? 0;

            if (this.attemptsLeft === 1 || this.attemptsLeft === 2) {
              this.captchaRendered = false; // <-- Reset the guard so captcha regenerates
              this.resetFormToInitialState();
            }
          } else {
            this.showerrorMessage = error.description;
            this.notify.emit('LOGIN_ERROR');
          }
          this.loadingService.stopLoading(); // Stop loader before returning
          return of(null);
        })
      ).subscribe((response: HttpResponse<AuthAPIResponse<MFAPrefrences>> | null) => {
        this.loadingService.stopLoading();
        if (!response) { // Null emitted from catchError
          return;
        }
        const data = response?.body?.data;
        this.sessionService.createNonEncryptedStorageMapping("enforcePwdPolicy", data?.enforcePwdPolicyYN)
        if (data?.enforcePwdPolicyYN) {
          this.PasswordPolicyApply(data?.expireIn);
          return;
        }

        // If MFA is expired, remove the cookie
        if (data?.isMFAExpire) {
          const userAgent = window.navigator.userAgent;
          const encodedAgent = CryptoJS.SHA256(userAgent).toString();
          const encodedClientId = CryptoJS.SHA256(this.loginForm.get('userID')?.value).toString();
          const key = `${encodedAgent}|${encodedClientId}`;
          this.cookieService.remove(key);
        }

        // Only run this if the cookie was NOT found
        if (!data?.isMFAExpire) {
          this.login();
        } else if (data?.isMFAEnabled === 1 || data?.isUserMFAEnable === 1) {
          forkJoin({
            mfaPref: of(data),
            clientMfaResponse: this.getClientMFAdetails()
          }).subscribe((combined: { mfaPref: MFAPrefrences; clientMfaResponse: APIResponse<MFAUserPreferences> }) => {
            const clientMfa = {
              ...combined.clientMfaResponse.Data,
              userId: userID,
              password: this.authService.encodeBase64(this.loginForm.get('password')?.value)
            };
            this.clientMfa = clientMfa;
            this.MfaPrefInfo = combined.mfaPref;
            this.mfaDataService.setMfaData({
              mfaPref: combined.mfaPref,
              clientMfa: clientMfa,
              responseStatus: combined.clientMfaResponse.HttpStatusCode,
              responseMessage: combined.clientMfaResponse.Message
            });
            this.loadingService.stopLoading();
            this.router.navigateByUrl(`/mfa`);
          });
        } else {
          this.login();
        }

      });
    }

  }

  sendAccountLockedNotification(userID: any) {
    const requestBody: UserAccLockedPayload = {
      UserId: userID,
      AccessCode: this.accessCode
    }
    this.authSubscription = this.authMFAService.UserAccLocked(requestBody).pipe(
      catchError((error: any) => {
        this.logService.error('Error while sending mail', error);
        return of(null);
      })
    ).subscribe((response: APIResponse<boolean> | null) => {
      if (response) {
        console.log('Account locked notification response:', response);
      } else {
        console.log('Failed to send account locked notification', response);
      }
    });
  }

  login() {
    const requestBody: LoginCredentialWithClientSecret = {
      code: this.accessCode,
      userID: this.loginForm.get('userID')!.value,
      password: this.authService.encodeBase64(this.loginForm.get('password')?.value),
      clientId: this.appService.getAppSettings().cfgPkg.cfgC,
      //clientSecret: this.appService.getAppSettings().cfgPkg.cfgD,
      deviceToken: this.cookieValue ? this.cookieValue : '',
      BaseURL: window.location.hostname
    }
    this.processAuthenticationRequest(requestBody, true);
    // this.authSubscription = this.authService.getTokenAndJTI(requestBody).pipe(
    //   tap(tokenAndJTIResponse => {
    //     newJTI = tokenAndJTIResponse.data.jti;
    //     newToken = tokenAndJTIResponse.data.token;
    //     this.authService.saveTokenAndJTIOnSystemStorage(tokenAndJTIResponse.data.jti, tokenAndJTIResponse.data.token);
    //   }),
    //   catchError(error => {
    //     console.log('Error Name:');
    //     console.log(error.name);
    //     console.log('Error Message:');
    //     console.log(error.message);
    //     console.log('Error Stack:');
    //     console.log(error.stack);
    //     if (error instanceof BusinessError)
    //       throw new BusinessError(error.title as BusinessOperationErrorTypes, error.description);
    //     else
    //       throw new BusinessError('LOGIN_ERROR', 'Something went wrong.');
    //   }),
    //   concatMap(tokenAndJTIResponse => this.authService.getUserIDAndRefreshToken(tokenAndJTIResponse.data)),
    //   tap(userIDAndRefreshTokenResponse => {
    //     userID = userIDAndRefreshTokenResponse.Data.UserId;
    //     refreshToken = userIDAndRefreshTokenResponse.Data.RefreshToken;
    //   }),
    //   concatMap(_ => this.authService.getLicenseDetails(newToken, newJTI)),
    //   tap(licenseDetailsResponse => {
    //     this.authService.checkLicenseExpiry(licenseDetailsResponse.Data);
    //     userLicenseDetails = licenseDetailsResponse.Data;
    //   }),
    //   concatMap(_ => this.authService.getUserTypeDetailsByID(userID, newJTI, newToken)),
    //   tap(userDetailsResponse => userDetails = userDetailsResponse.Data),
    //   concatMap(_ => this.authService.performProfessionalActivationCheck(userID, newToken, newJTI)),
    //   concatMap(userAllowedToLogin => {
    //     if (!userAllowedToLogin) throw new BusinessError('USER_NOT_LINKED_WITH_CLIENTS', 'Professional not linked with any active clients.');

    //    if (userDetails.hasOwnProperty('ClientID')) {
    //       userType = 'CLT';
    //       this.saveUserData(forClient, userDetails, userLicenseDetails, newToken, refreshToken, newJTI);
    //       return this.authService.updateLoginLogoutStatus(newToken, newJTI, userID, userType, "Y").pipe(
    //         mergeMap(_ => this.dashboardService.getMenuListData(userType, "1", newToken, newJTI))
    //       );
    //     }
    //     else {
    //       userType = 'PRF';
    //       forClient = false;
    //       this.saveUserData(forClient, userDetails, userLicenseDetails, newToken, refreshToken, newJTI);
    //       return this.authService.updateLoginLogoutStatus(newToken, newJTI, userID, userType, "Y").pipe(
    //         mergeMap(_ =>this.dashboardService.getMenuListData(userType, "0", newToken, newJTI, (userDetails as ProfessionalUserData).LevelName))
    //       );
    //     }
    //   }),
    //   map((menuOptions: Array<Menu>) => this.getLandingPageRoute(userType, menuOptions[0].optionPath, newJTI))
    // ).subscribe({
    //   next: (landingPageRoute) => {
    //     // COOKIES SETTINGS.
    //     const rememberMeIsChecked = this.loginForm.value.rememberMe;
    //     const usingMobileDevice = this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
    //     if (rememberMeIsChecked) {
    //       let cookieData = {} as CookieData;
    //       cookieData.jti = newJTI;
    //       cookieData.token = newToken;
    //       cookieData.refreshToken = refreshToken;
    //       this.authService.setKeepMeLoggedIn(this.encryptionService.encryptData(JSON.stringify(cookieData)));
    //     }
    //     else {
    //       this.authService.removeKeepMeLoggedIN();
    //     }

    //     this.logService.appLogin("LoggedIn", { jti: newJTI, user_id: userID }, usingMobileDevice, newToken, newJTI);

    //      this.loadingService.stopLoading();
    //      this.router.navigateByUrl(landingPageRoute as string);
    //   },

    //   error: (error) => {
    //     console.log('Error Name:');
    //     console.log(error.name);
    //     console.log('Error Message:');
    //     console.log(error.message);
    //     console.log('Error Stack:');
    //     console.log(error.stack);
    //     if (error instanceof BusinessError) {
    //       this.notify.next(error.title as AuthFormNotificationType);
    //     }
    //     else if (error instanceof CategorizedError) {
    //       this.snackbarService.showErrorSnackBar(error.title, error.description, 'none');
    //     }
    //     else {
    //       this.notify.next('LOGIN_ERROR');
    //     }
    //     this.loadingService.stopLoading();
    //   }
    // });
  }

  loginOld() {
    let newJTI: string = '';
    let newToken: string = '';
    let ukRef: string = '';
    let jtiPkr: string = '';
    let userID: string = '';
    let forClient = true;
    let userType: "CLT" | "PRF" | "STF" = "CLT";

    let refreshToken: string = '';
    let userLicenseDetails: UserLicenseDetail;
    let userDetails: UnspecifiedUserTypeData;

    const requestBody: LoginCredentialWithClientSecret = {
      code: this.accessCode,
      userID: this.loginForm.get('userID')!.value,
      password: this.authService.encodeBase64(this.loginForm.get('password')?.value),
      clientId: this.appService.getAppSettings().cfgPkg.cfgC,
      //clientSecret: this.appService.getAppSettings().cfgPkg.cfgD,
      deviceToken: this.cookieValue ? this.cookieValue : '',
      BaseURL: window.location.hostname
    }
    this.processAuthenticationRequest(requestBody, true);
    this.authSubscription = this.authService.getTokenAndJTI(requestBody).pipe(
      tap((tokenAndJTIResponse: any) => {
        newJTI = tokenAndJTIResponse.data.jti;
        newToken = tokenAndJTIResponse.data.token;
        ukRef = tokenAndJTIResponse.data.ukRef;
        jtiPkr = tokenAndJTIResponse.data.jtiPkr;
        this.authService.saveTokenAndJTIOnSystemStorage(tokenAndJTIResponse.data.jti, tokenAndJTIResponse.data.token,
          tokenAndJTIResponse.data.ukRef, tokenAndJTIResponse.data.jtiPkr);
      }),
      catchError((error: any) => {
        console.log('Error Name:');
        console.log(error.name);
        console.log('Error Message:');
        console.log(error.message);
        console.log('Error Stack:');
        console.log(error.stack);
        if (error instanceof BusinessError)
          throw new BusinessError(error.title as BusinessOperationErrorTypes, error.description);
        else
          throw new BusinessError('LOGIN_ERROR', 'Something went wrong.');
      }),
      concatMap((tokenAndJTIResponse: any) => this.authService.getUserIDAndRefreshToken(tokenAndJTIResponse.data)),
      tap((userIDAndRefreshTokenResponse: any) => {
        userID = userIDAndRefreshTokenResponse.Data.UserId;
        refreshToken = userIDAndRefreshTokenResponse.Data.RefreshToken;
      }),
      concatMap(_ => this.authService.getLicenseDetails(newToken, newJTI, ukRef, jtiPkr)),
      tap((licenseDetailsResponse: any) => {
        this.authService.checkLicenseExpiry(licenseDetailsResponse.Data);
        userLicenseDetails = licenseDetailsResponse.Data;
      }),
      concatMap(_ => this.authService.getUserTypeDetailsByID(userID, newJTI, newToken, ukRef, jtiPkr)),
      tap((userDetailsResponse: any) => userDetails = userDetailsResponse.Data),
      concatMap(_ => this.authService.performProfessionalActivationCheck(userID, newToken, newJTI)),
      concatMap((userAllowedToLogin: any) => {
        if (!userAllowedToLogin) throw new BusinessError('USER_NOT_LINKED_WITH_CLIENTS', 'Professional not linked with any active clients.');

        if (userDetails.hasOwnProperty('ClientID')) {
          userType = 'CLT';
          this.saveUserData(forClient, userDetails, userLicenseDetails, newToken, refreshToken, newJTI);
          return this.authService.updateLoginLogoutStatus(newToken, newJTI, userID, userType, "Y").pipe(
            mergeMap(_ => this.dashboardService.getMenuListData(userType, "1", newToken, newJTI))
          );
        }
        else {
          userType = 'PRF';
          forClient = false;
          this.saveUserData(forClient, userDetails, userLicenseDetails, newToken, refreshToken, newJTI);
          return this.authService.updateLoginLogoutStatus(newToken, newJTI, userID, userType, "Y").pipe(
            mergeMap(_ => this.dashboardService.getMenuListData(userType, "0", newToken, newJTI, (userDetails as ProfessionalUserData).LevelName))
          );
        }
      }),
      map((menuOptions: Array<Menu>) => this.getLandingPageRoute(userType, menuOptions[0].optionPath, newJTI))
    ).subscribe({
      next: (landingPageRoute: any) => {
        // COOKIES SETTINGS.
        const rememberMeIsChecked = this.loginForm.value.rememberMe;
        const usingMobileDevice = this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
        if (rememberMeIsChecked) {
          let cookieData = {} as CookieData;
          cookieData.jti = newJTI;
          cookieData.token = newToken;
          cookieData.refreshToken = refreshToken;
          this.authService.setKeepMeLoggedIn(this.encryptionService.encryptData(JSON.stringify(cookieData)));
        }
        else {
          this.authService.removeKeepMeLoggedIN();
        }

        this.logService.appLogin("LoggedIn", { jti: newJTI, user_id: userID }, usingMobileDevice, newToken, newJTI);

        this.loadingService.stopLoading();
        this.router.navigateByUrl(landingPageRoute as string);
      },
      error: (error: any) => {
        console.log('Error Name:');
        console.log(error.name);
        console.log('Error Message:');
        console.log(error.message);
        console.log('Error Stack:');
        console.log(error.stack);
        if (error instanceof BusinessError) {
          this.notify.next(error.title as AuthFormNotificationType);
        }
        else if (error instanceof CategorizedError) {
          this.snackbarService.showErrorSnackBar(error.title, error.description, 'none');
        }
        else {
          this.notify.next('LOGIN_ERROR');
        }
        this.loadingService.stopLoading();
      }
    });
  }



  private processAuthenticationRequest(payload: any, shouldRedirect: boolean = true): void {
    let newJTI: string = '';
    let newToken: string = '';
    let ukRef: string = '';
    let jtiPkr: string = '';
    let userID: string = '';
    let forClient = true;
    let userType: "CLT" | "PRF" | "STF" = "CLT";

    let refreshToken: string = '';
    let userLicenseDetails: UserLicenseDetail;
    let userDetails: UnspecifiedUserTypeData;

    this.notify.emit(null);
    this.loadingService.showLoading();
    this.authSubscription = this.authService.getTokenAndJTI(payload).pipe(
      tap((tokenAndJTIResponse: any) => {
        if (tokenAndJTIResponse.data.isMFAExpire) {
          const userAgent = window.navigator.userAgent;
          const encodedAgent = CryptoJS.SHA256(userAgent).toString();
          const encodedClientId = CryptoJS.SHA256(this.loginForm.get('userID')?.value).toString();
          const key = `${encodedAgent}|${encodedClientId}`;
          this.cookieService.remove(key);
          this.router.navigateByUrl(`/mfa`);
        }
        newJTI = tokenAndJTIResponse.data.jti;
        newToken = tokenAndJTIResponse.data.token;
        ukRef = tokenAndJTIResponse.data.ukRef;
        jtiPkr = tokenAndJTIResponse.data.jtiPkr;
        this.authService.saveTokenAndJTIOnSystemStorage(tokenAndJTIResponse.data.jti, tokenAndJTIResponse.data.token,
          tokenAndJTIResponse.data.ukRef, tokenAndJTIResponse.data.jtiPkr);
      }),
      catchError((error: any) => {
        if (
          !payload?.verificationOTP ||
          typeof payload?.verificationOTP !== 'string' ||
          payload?.verificationOTP?.trim() === ''
        ) {
          this.snackbarService.showErrorSnackBar('Error', "Verification failed. Check your answers and try again.", '');
        } else {
          this.mfaDataService.loginTriggerSubject.next({ error: error?.title });
        }
        if (error instanceof BusinessError)
          throw new BusinessError(error.title as BusinessOperationErrorTypes, error.description);
        else
          throw new BusinessError('LOGIN_ERROR', 'Something went wrong.');
      }),
      concatMap((tokenAndJTIResponse: any) => this.authService.getUserIDAndRefreshToken(tokenAndJTIResponse.data)),
      tap((userIDAndRefreshTokenResponse: any) => {
        userID = userIDAndRefreshTokenResponse.Data.UserId;
        refreshToken = userIDAndRefreshTokenResponse.Data.RefreshToken;
      }),
      concatMap(_ => this.authService.getLicenseDetails(newToken, newJTI, ukRef, jtiPkr)),
      tap((licenseDetailsResponse: any) => {
        this.authService.checkLicenseExpiry(licenseDetailsResponse.Data);
        userLicenseDetails = licenseDetailsResponse.Data;
      }),
      concatMap((_: any) => this.authService.getUserTypeDetailsByID(userID, newJTI, newToken, ukRef, jtiPkr)),
      tap((userDetailsResponse: any) => userDetails = userDetailsResponse.Data),
      concatMap(_ => this.authService.performProfessionalActivationCheck(userID, newToken, newJTI)),
      concatMap((userAllowedToLogin: any) => {
        if (!userAllowedToLogin) {
          this.showerrorMessage = '';
          throw new BusinessError('USER_NOT_LINKED_WITH_CLIENTS', 'Professional not linked with any active clients.');


        }
        if (userDetails.hasOwnProperty('ClientID')) {
          userType = 'CLT';
          this.saveUserData(forClient, userDetails, userLicenseDetails, newToken, refreshToken, newJTI);
          return this.authService.updateLoginLogoutStatus(newToken, newJTI, userID, userType, "Y").pipe(
            mergeMap(_ => this.dashboardService.getMenuListData(userType, "1", newToken, newJTI, "", "", ukRef, jtiPkr))
          );
        }
        else {
          userType = 'PRF';
          forClient = false;
          this.saveUserData(forClient, userDetails, userLicenseDetails, newToken, refreshToken, newJTI);
          return this.authService.updateLoginLogoutStatus(newToken, newJTI, userID, userType, "Y").pipe(
            mergeMap(_ => this.dashboardService.getMenuListData(userType, "0", newToken, newJTI,
              (userDetails as ProfessionalUserData).LevelName, "", ukRef, jtiPkr))
          );
        }
      }),
      map((menuOptions: Array<Menu>) => this.getLandingPageRoute(userType, menuOptions[0].optionPath, newJTI))
    ).subscribe({
      next: (landingPageRoute: any) => {
        // COOKIES SETTINGS.
        this.loginSubscription.unsubscribe();
        const rememberMeIsChecked = this.loginForm.value.rememberMe;
        const usingMobileDevice = this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
        if (rememberMeIsChecked) {
          let cookieData = {} as CookieData;
          cookieData.jti = newJTI;
          cookieData.token = newToken;
          cookieData.refreshToken = refreshToken;
          this.authService.setKeepMeLoggedIn(this.encryptionService.encryptData(JSON.stringify(cookieData)));
        }
        else {
          this.authService.removeKeepMeLoggedIN();
        }
        this.logService.appLogin("LoggedIn", { jti: newJTI, user_id: userID }, usingMobileDevice, newToken, newJTI);
        this.mfaDataService.jti = newJTI;
        this.mfaDataService.landingPageRoute = landingPageRoute as string;
        this.mfaDataService.loginTriggerSubject.next({ error: '' });
        this.loadingService.stopLoading();
        if (this.MfaPrefInfo?.isPreferenceSet === 1 || shouldRedirect) {
          this.router.navigateByUrl(landingPageRoute as string);
          this.checkAndStoreMfaCookie(this.loginForm.get('userID')?.value);
        }
      },

      error: (error: any) => {
        // console.log('Error Name:');
        // console.log(error.name);
        // console.log('Error Message:');
        // console.log(error.message);
        // console.log('Error Stack:');
        // console.log(error.stack);
        //this.showerrorMessage = error.description;
        if (error instanceof BusinessError) {
          this.notify.emit(error.title as AuthFormNotificationType);
        }
        else if (error instanceof CategorizedError) {
          this.snackbarService.showErrorSnackBar(error.title, error.description, 'none');
        }
        else {
          this.notify.emit('LOGIN_ERROR');
        }
        this.loadingService.stopLoading();
      }
    });
  }

  togglePasswordDisplay() {
    this.hidePassword = !this.hidePassword;
    this.togglePasswordFieldIcon();
  }

  togglePasswordFieldIcon() {
    this.toggleIcon = (this.toggleIcon === 'fa-eye-slash') ? 'fa-eye' : 'fa-eye-slash';
  }

  saveUserData(forClient: boolean, userDetails: UnspecifiedUserTypeData, userLicense: UserLicenseDetail, token: string, refreshToken: string, jti: string) {
    // userIsClient = this.authService.determineIfUserIsClient(userDetails);
    if (forClient) {
      userDetails = userDetails as Exclude<UnspecifiedUserTypeData, ProfessionalUserData>;
      this.authService.saveAllUserDataOnSystemStorage<ClientUserData>(forClient, userDetails, userLicense, token, refreshToken, jti);
    } else {
      userDetails = userDetails as Exclude<UnspecifiedUserTypeData, ClientUserData>;
      this.authService.saveAllUserDataOnSystemStorage<ProfessionalUserData>(forClient, userDetails, userLicense, token, refreshToken, jti);
    }
  }

  getLandingPageRoute(userType: "CLT" | "PRF" | "STF", pageSection: string, jti: string): string {
    let userTypeSection = '';

    switch (userType) {
      case "CLT":
        userTypeSection = 'client';
        break;

      case "PRF":
        userTypeSection = 'professional';
        break;

      case "STF":
        userTypeSection = 'staff';
        break;

      default:
        userTypeSection = 'unknown';
        break;
    }

    const route = `/${userTypeSection}/${jti}/${pageSection}`;
    return route;
  }

  showPasswordRecoveryForm() {
    this.formChange.emit("RECOVERY");
  }

  showuseridRecoveryForm() {
    this.formChange.emit("FORGOTUSERID");
  }

  openTermsAndConditionsDialog(switchedOn: boolean) {
    let dialogRef: MatDialogRef<TermsAndConditionsDialogComponent, boolean>;
    if (switchedOn) {
      const dialogConfigs: MatDialogConfig = {
        id: 'privacy-policy-dialog',
        position: {
          bottom: '5vh'
        }
      };

      dialogRef = this.matDialog.open(TermsAndConditionsDialogComponent, dialogConfigs);
      dialogRef.afterClosed().subscribe((accepted: any) => {
        if (!accepted) {
          this.loginForm.controls['rememberMe'].setValue(false);
        }
      })
    }
  }

  private getClientMFAdetails() {
    const payload: MFAClientIdPayload = {
      ClientId: this.loginForm.get('userID')?.value,
      AccessCode: this.accessCode
    };
    return this.authMFAService.getClientMFADetials(payload);

  }

  // OTP verification

  public verifyOTP(param: string | { id: any; //question: any; 
    answer: any; }[]) {
    if (!this.clientMfa) return;
    const { userID } = this.loginForm.value;
    const payload = {
      code: this.accessCode,
      userID,
      mfaAuthType: this.clientMfa.DefaultAuth,
      verificationOTP: typeof param === "string" ? param : '',
      mfaSecretKey: this.clientMfa.MFASecretKey,
      password: this.authService.encodeBase64(this.loginForm.get('password')?.value),
      clientId: this.appService.getAppSettings().cfgPkg.cfgC,
      //clientSecret: this.appService.getAppSettings().cfgPkg.cfgD,
      mfaSecurityQuesAnswers: param instanceof Array ? param : null,
      MFAValidTillDays: this.mfaDataService.rememberMe ? this.clientMfa?.NextAuthDays : null,
      deviceToken: this.deviceToken,
      BaseURL: window.location.hostname
    };
    this.processAuthenticationRequest(payload, false);
  }

  private getMfaCookieKey(userId: string): string {
    const userAgent = window.navigator.userAgent;
    const encodedAgent = CryptoJS.SHA256(userAgent).toString();
    const encodedClientId = CryptoJS.SHA256(userId).toString();
    return `${encodedAgent}|${encodedClientId}`;
  }
  private checkAndStoreMfaCookie(userId: string) {
    const key = this.getMfaCookieKey(userId);
    if (this.mfaDataService.rememberMe && !this.cookieService.hasKey(key)) {
      this.storeMfaCookie(userId);
    }
  }

  storeMfaCookie(clientId: string) {
    const userAgent = window.navigator.userAgent;
    //console.log("userAgent",userAgent)
    const encodedAgent = CryptoJS.SHA256(userAgent).toString();
    const encodedClientId = CryptoJS.SHA256(clientId).toString();
    const key = `${encodedAgent}|${encodedClientId}`;
    const value = this.deviceToken ?? this.generateRandomString(25);
    const expires = new Date();
    expires.setDate(expires.getDate() + 20);
    this.cookieService.put(key, value, { expires });
  }

  // Helper to generate a random string
  private generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  checkMfaCookie(clientId: string): boolean {
    const userAgent = window.navigator.userAgent;
    const encodedAgent = CryptoJS.SHA256(userAgent).toString();;
    const encodedClientId = CryptoJS.SHA256(clientId).toString();
    const key = `${encodedAgent}|${encodedClientId}`;
    this.cookieValue = this.cookieService.get(key);
    if (this.cookieValue) {
      return true;
    } else {
      return false;
    }
  }


  // Checkbox and CAPTCHA handling methods
  onNotRobotCheckboxChange(checked: boolean): void {
    this.isNotRobotChecked = checked;
    this.showCaptcha = checked && (this.attemptsLeft === 1 || this.attemptsLeft === 2);

    if (!checked) {
      // Reset CAPTCHA when checkbox is unchecked
      this.captchaCompleted = false;
      this.captchaRendered = false;
      this.loginForm.get('Captcha')?.setValue('');
      this.loginForm.get('Captcha')?.clearValidators();
      this.loginForm.get('Captcha')?.updateValueAndValidity();
    }
  }

  resetFormToInitialState(): void {
    this.isNotRobotChecked = false;
    this.showCaptcha = false;
    this.captchaCompleted = false;
    this.captchaRendered = false;
    this.loginForm.get('NotRobotCheckbox')?.setValue(false);
    this.loginForm.get('Captcha')?.setValue('');
    this.loginForm.get('Captcha')?.clearValidators();
    this.loginForm.get('Captcha')?.updateValueAndValidity();
  }

  // Check if form is valid for submission
  get formIsValid(): boolean {
    const baseFormValid = (this.loginForm.get('userID')?.valid ?? false) && (this.loginForm.get('password')?.valid ?? false);

    if (this.attemptsLeft === 1 || this.attemptsLeft === 2) {
      const checkboxChecked = this.isNotRobotChecked;
      const captchaValid = (this.loginForm.get('Captcha')?.value?.length ?? 0) === 6;
      return baseFormValid && checkboxChecked && captchaValid;
    }

    return baseFormValid;
  }

  ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
    this.formValueChangesSubscription.unsubscribe();
  }
  PasswordPolicyApply(expireIn?: number) {
    this.recoverPassword(expireIn);
    const dialogRef = this.dialog.open(PasswordPolicyComponent, {
      width: '100%',
      maxWidth: '470px',
      panelClass: 'password-policy-dialog',
    });


  }
  recoverPassword(expireIn?: number) {

    const form = {
      'ClientId': this.loginForm.get('userID')!.value,
      URL: window.location.origin + '/setpassword?tag=',
      AccessCode: this.accessCode,
      IsPeriodicPasswordResetEnforce: 1,
      ExpiryDays: expireIn
    };
    let ClientID = this.loginForm.get('userID')!.value;
    const url = window.location.origin + '/setpassword?tag=';


    this.authService.recoverPasswordv2({ ClientID: ClientID, EmailID: '', AccessCode: this.accessCode, URL: url, IsPeriodicPasswordResetEnforce: 1, ExpiryDays: expireIn }).subscribe(response => {
      if (response?.Data) {


      }
      this.loadingService.stopLoading();
    });
  }



}

function clientIdFieldValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const clientId = control.value;

    if (clientId.length > 0 && clientId.length < 10) return { invalidLength: true }
    else return null;
  }
}




